import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ToolkitStore } from '@reduxjs/toolkit/dist/configureStore';
import { apiGetRouteNav } from '../api';
import { AppStore, RecordList, RouteNav } from '../types';

// 请求成功时传送的参数
interface SuccessParams {
  list: Array<RouteNav>;
}
// 请求失败时传送的参数
interface FailureParams {
  error: string;
}

const routeNavSlice = createSlice({
  name: 'routeNav',
  initialState: { fetching: false, loaded: false } as RecordList<RouteNav>,
  reducers: {
    routeNavRequest: (state: RecordList<RouteNav>, action: PayloadAction) => {
      state.fetching = true;
      return state;
    },
    routeNavSuccess: (state: RecordList<RouteNav>, action: PayloadAction<SuccessParams>) => {
      state.fetching = false;
      state.loaded = true;
      state.results = action.payload.list;
      return state;
    },
    routeNavFailure: (state: RecordList<RouteNav>, action: PayloadAction<FailureParams>) => {
      state.fetching = false;
      state.loaded = true;
      state.error = action.payload.error;
      return state;
    },
    routeNavClear: (state: RecordList<RouteNav>) => {
      state = { fetching: false, loaded: false } as RecordList<RouteNav>;
      return state;
    },
  },
});

export const { routeNavRequest, routeNavSuccess, routeNavFailure, routeNavClear } = routeNavSlice.actions;
export default routeNavSlice.reducer;

export const routeNavEffect = {
  'routeNav/clear': (store: ToolkitStore<AppStore>) => store.dispatch(routeNavClear()),
  'routeNav/routeNavRequest': async (store: ToolkitStore<AppStore>, action: PayloadAction) => {
    let list = store.getState().routeNav;
    if (list?.loaded === true && !list?.error) {
      store.dispatch(routeNavSuccess({ list: list.results ?? [] }));
    } else {
      try {
        let res = await apiGetRouteNav();
        let data = res.data;
        if (data.code === 200) {
          store.dispatch(routeNavSuccess({ list: data.data }));
        } else {
          store.dispatch(routeNavFailure({ error: data.msg || '获取失败' }));
        }
      } catch (e: any) {
        store.dispatch(routeNavFailure({ error: e.toString() || '获取失败' }));
      }
    }
  },
};
